import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 5,
	height: 9,
	fill: "none",
	viewBox: "0 0 5 9",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#545F7E",
		fillRule: "evenodd",
		d: "M4.86.14a.48.48 0 010 .68L1.357 4.32l3.501 3.501a.48.48 0 01-.679.68L0 4.32 4.18.141a.48.48 0 01.68 0z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgBackArrow);
export default ForwardRef;
